import { useMutation } from "@tanstack/react-query";

import { authClient } from "lib/auth/authClient";
import { SKIP_SENTRY_FOR_CLIENT_ERRORS } from "lib/sentryErrors";
import { BetterAuthError } from "./utils";

// better-auth returns this when the token is unknown, already used, or past its one-hour expiry.
export const INVALID_RESET_TOKEN_CODE = "INVALID_TOKEN";

/**
 * Completes the better-auth password-reset flow: exchanges the one-time token from the emailed reset
 * link for a new password. The raw better-auth error is thrown so callers can branch on its `code`.
 * @returns A mutation object with methods to submit the new password and track its status.
 */
export function useResetPassword() {
  return useMutation<
    { status: boolean } | null,
    BetterAuthError,
    { newPassword: string; token: string }
  >({
    meta: SKIP_SENTRY_FOR_CLIENT_ERRORS,
    mutationKey: ["resetPassword"],
    mutationFn: async ({ newPassword, token }) => {
      const { data, error } = await authClient.resetPassword({ newPassword, token });
      if (error) {
        throw error;
      }
      return data;
    },
  });
}
